import { Component, OnInit } from '@angular/core';
import { IrpfListModel } from './irpfList.model';
import { InvoiceService } from '../../invoice/invoice/invoice.service';
import { Router } from "@angular/router";
import * as FileSaver from 'file-saver';
import { ExpensesIrpfListConst } from '../const';
import { Utils } from '../../../shared/utils';
import { consts } from '../../../consts';
import { AddFileService } from '../../../shared/components/add-file/add-file.service';

@Component({
    selector: 'convfact-irpflist',
    styleUrls: ['expense.component.css'],
    templateUrl: 'irpf-list.component.html',
    standalone: false
})
export class IrpfListComponent implements OnInit {

    constructor(
        private invoiceService: InvoiceService,
        private router: Router,
        private addFileService: AddFileService) { }

    ready: boolean = false;
    empty: boolean = false;
    spinner: boolean = false;
    irpfList: IrpfListModel[] = [];
    trimester: string;
    headerTable: any[] = ExpensesIrpfListConst.headerTable;

    export(): void {
        this.spinner = true;
        const data = new IrpfListModel;
        data.trimester = this.trimester;
        this.invoiceService.exportIrpfList(data, true).then(response => {
            FileSaver.saveAs(response, Utils.GetExcelName("IRPF_Soportado"));
            this.spinner = false;
        })
    }

    change() {
        this.router.navigate(['/expense/irpf/' + this.trimester]);
        this.ready = true;
    }

    proximamente() {
        alert("Próximamente");
    }

    go() {
        this.spinner = true;
        this.invoiceService.irpfList(this.trimester, true).then(response => {
            this.irpfList = response;
            this.irpfList.forEach(irpf => {
                irpf.base = Utils.GetValueWithDecimals(irpf.base);
                irpf.amount = Utils.GetValueWithDecimals(irpf.amount);
            });

            this.spinner = false;
            if (this.irpfList.length == 0) {
                this.empty = true;
            }
        })
    }

    ngOnInit() {
        const params = this.router.url.split('/');
        this.trimester = params[3];
    }

    downloadFileImage(expenseUid: string): void {
        this.spinner = true;
        this.addFileService.downloadFileImage(expenseUid, consts.INVOICE_ENTITY, consts.EMPTY_GUID).then(response => {
            FileSaver.saveAs(response, Utils.GetFileName("Gasto", consts.EXT_PNG));
            this.spinner = false;
        })
    }

    downloadFilePdf(expenseUid: string): void {
        this.spinner = true;
        this.addFileService.downloadFilePDF(expenseUid, consts.INVOICE_ENTITY, consts.EMPTY_GUID).then(response => {
            FileSaver.saveAs(response, Utils.GetPdfName("Gasto"));
            this.spinner = false;
        })
    }

  public trackByIndex(i: number) { return i; }

}
